export const BID_MAP = {
    // 邀请好友按钮相关
    INVITE_FRIEND_BUTTON_EXPOSURE: 'b_daodian_lowcode_06ky3fe4_mv',
    // 比价组件邀请好友按钮曝光
    INVITE_FRIEND_BUTTON_CLICK: 'b_daodian_lowcode_424xjbpc_mc',
    // 比价组件邀请好友按钮点击
    // 换一批按钮相关
    CHANGE_BATCH_BUTTON_EXPOSURE: 'b_daodian_lowcode_lu86wnwg_mv',
    // 比价组件换一批按钮曝光
    CHANGE_BATCH_BUTTON_CLICK: 'b_daodian_lowcode_i7p3ncjk_mc',
    // 比价组件换一批按钮点击
    // 查看会场按钮相关
    VIEW_VENUE_BUTTON_EXPOSURE: 'b_daodian_lowcode_k37gj0kx_mv',
    // 查看会场按钮曝光
    VIEW_VENUE_BUTTON_CLICK: 'b_daodian_lowcode_oet3mfft_mc',
    // 查看会场按钮点击
    // 同步好友按钮相关
    SYNC_FRIEND_BUTTON_EXPOSURE: 'b_daodian_lowcode_nlzj10fw_mv',
    // 同步好友按钮曝光
    SYNC_FRIEND_BUTTON_CLICK: 'b_daodian_lowcode_n08j0z6l_mc' // 同步好友按钮点击
};
export var BID_TYPE;
(function (BID_TYPE) {
    BID_TYPE["MV"] = "mv";
    BID_TYPE["MC"] = "mc";
    BID_TYPE["MC_WITH_TAG"] = "mc_with_tag";
})(BID_TYPE || (BID_TYPE = {}));
